import {
  Stack,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { productImportWarehouseBusiness } from "api/bussiness/product/product-import-warehouse-bussiness";
import { ProductInventoryPermission } from "commons/enum/permission";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { cloneDeep } from "lodash";
import { observer } from "mobx-react-lite";
import { IProductGoodsReceiptProperties } from "mobx-stores/_models/product-inventory/product-goods-receipt/product-goods-receipt";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect } from "react";
import { NumberText } from "share-components/atomics/number-text";
import {
  EditIconButton,
  RemoveIconButton,
} from "share-components/mui-wrap/button/action-button";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";
export const ProductGoodsReceiptTable = observer(() => {
  const {
    deleteConfirmationStore,
    productInventoryManagement: {
      productGoodsReceiptStore: {
        productGoodsReceipts,
        getProductGoodsReceipt,
        pagination,
        setProp,
      },
    },
  } = useStores();

  useEffect(() => {
    getProductGoodsReceipt();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPageChanged = useCallback(
    (_: any, page: number) => {
      pagination.setProp("pageIndex", page - 1);

      getProductGoodsReceipt();
    },
    [getProductGoodsReceipt, pagination]
  );

  const onEditBtnClickHandler = useCallback(
    (item: IProductGoodsReceiptProperties) => {
      setProp("openEdit", true);
      setProp("productGoodsReceiptDetail", cloneDeep(item));
    },
    [setProp]
  );

  const onDelete = useCallback(
    async (item: IProductGoodsReceiptProperties) => {
      if (item && item.id) {
        await productImportWarehouseBusiness.delete(item?.id);
        getProductGoodsReceipt();
      }
    },
    [getProductGoodsReceipt]
  );

  const onDeleteBtnClickHandler = useCallback(
    (item: IProductGoodsReceiptProperties) => {
      setProp("productGoodsReceiptDetail", cloneDeep(item));
      deleteConfirmationStore.setProp("open", true);
      deleteConfirmationStore.setDeletionCallback(() => {
        onDelete(item);
      });
    },
    [deleteConfirmationStore, onDelete, setProp]
  );
  return (
    <XTablePagination
      paginationProps={{
        count: pagination.totalPages,
        page: pagination.pageNumber,
        onChange: onPageChanged,
      }}
    >
      <TableHead>
        <TableRow>
          <TableCell>Mã hàng</TableCell>
          <TableCell>Tên hàng</TableCell>
          <TableCell>Ngày nhập</TableCell>
          <TableCell>Số lượng</TableCell>
          <TableCell>Vị trí</TableCell>
          <TableCell>Ghi chú</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {productGoodsReceipts.map((x, i) => (
          <TableRow data-id={x.id} key={x.id} hover>
            <TableCell>{x.items[0]?.product?.code}</TableCell>
            <TableCell>{x.items[0]?.product?.name}</TableCell>
            <TableCell>{dateTimeDisplay(x.importDate)}</TableCell>
            <TableCell>
              <NumberText value={x.items[0]?.quantity}></NumberText>
            </TableCell>
            <TableCell>{x.items[0]?.location || ""}</TableCell>
            <TableCell>{x.items[0]?.note}</TableCell>
            <TableCell width={"20px"}>
              <Stack direction={"row"} spacing={0.5}>
                <EditIconButton
                  accessPermission={[ProductInventoryPermission.ImportUpdate]}
                  onClick={() => onEditBtnClickHandler(x)}
                ></EditIconButton>

                <RemoveIconButton
                  accessPermission={[ProductInventoryPermission.ImportDelete]}
                  onClick={() => onDeleteBtnClickHandler(x)}
                ></RemoveIconButton>
              </Stack>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </XTablePagination>
  );
});
